import Konva from 'konva'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      pathCount: 1,
      drawLayer: null,
      mappingDataLoaded: false,
      transformShape: null
    }
  },
  computed: {
    ...mapGetters(['idToken']),
    templateMaps () {
      return this.trainTemplateData.template_mappings
    }
  },
  methods: {
    populateMappings (pageMapping) {
      this.drawLayer = this.buildPageLayer(pageMapping)
      if (pageMapping && pageMapping.children) {
        this.buildMappingTree(this.drawLayer, pageMapping.children)
      }
      this.stage.add(this.drawLayer)
      this.stage.draw()
      this.setInitStack()

      this.updateMappingData()
    },

    buildMappingTree (parent, childMaps) {
      if (_.size(childMaps)) {
        childMaps.forEach((map) => {
          if (map.map_type === 'group') {
            let newGroup = this.buildGroup('logical', map)
            let holderShape = this.groupHolderShape(newGroup.attrs)

            newGroup.add(holderShape)
            parent.add(newGroup)

            if (parent.nodeType === 'Layer') {
              newGroup.setAttrs({
                path: parent.attrs.path + '.' + this.pathCount,
                x: newGroup.attrs.x_pos - parent.attrs.x,
                y: newGroup.attrs.y_pos - parent.attrs.y
              })
            } else {
              newGroup.setAttrs({
                path: parent.attrs.path + '.' + this.pathCount,
                x: newGroup.attrs.x_pos - parent.attrs.x_pos,
                y: newGroup.attrs.y_pos - parent.attrs.y_pos
              })
            }

            this.pathCount++
            this.bindListeners(newGroup)
            this.buildMappingTree(newGroup, map.children)
          } else {
            let newShape = this.buildShape(map)
            parent.add(newShape)

            if (parent.nodeType === 'Layer') {
              newShape.setAttrs({
                path: parent.attrs.path + '.' + this.pathCount,
                x: newShape.attrs.x_pos - parent.attrs.x,
                y: newShape.attrs.y_pos - parent.attrs.y
              })
            } else {
              newShape.setAttrs({
                path: parent.attrs.path + '.' + this.pathCount,
                x: newShape.attrs.x_pos - parent.attrs.x_pos,
                y: newShape.attrs.y_pos - parent.attrs.y_pos
              })
            }

            if (newShape.parent.nodeType === 'Group') {
              newShape.setAttr('draggable', false)
            } else {
              this.bindListeners(newShape)
            }

            this.pathCount++
          }
        })
      }
      return parent
    },

    buildGroup (mapType, attrs) {
      switch (mapType) {
        case 'logical':
          return this.buildLogicalGroup(attrs)
      }
    },

    buildPageLayer (attrs) {
      let pageLayer = new Konva.Layer({
        id: 'page_1',
        name: 'page_group',
        path: this.pathCount,
        map_type: 'page',
        edit_type: 'created',
        template_id: this.id,
        x: 0,
        y: 0,
        key: this.trainTemplateData.title,
        uniq_id: (Date.now()).toString(),
        draggable: false
      })

      this.pathCount++
      return pageLayer
    },

    buildLogicalGroup (attrs) {
      let newGroup = new Konva.Group({
        id: attrs.id,
        name: 'group',
        map_type: 'group',
        x_pos: Number(attrs.x_pos),
        y_pos: Number(attrs.y_pos),
        width: Number(attrs.width),
        height: Number(attrs.height),
        key: attrs.key,
        order: attrs.order,
        dataType: attrs.data_type,
        edit_type: 'created',
        template_id: attrs.template_id,
        uniq_id: (Date.now()).toString(),
        draggable: true,
        required: attrs.required,
        show_field: attrs.show_field,
        redact_field: attrs.redact_field
      })
      return newGroup
    },

    groupHolderShape (attrs) {
      let holderShape = new Konva.Rect({
        id: attrs.id,
        name: 'group_holder',
        map_type: 'group_holder',
        category: attrs.category,
        case: attrs.case_column,
        x: 0,
        y: 0,
        width: Number(attrs.width),
        height: Number(attrs.height),
        edit_type: false,
        template_id: attrs.template_id,
        uniq_id: (Date.now()).toString(),
        stroke: this.theme[this.selectedTheme].strokeColor,
        strokeWidth: 3,
        draggable: false,
        selected: false
      })
      return holderShape
    },

    buildShape (shape) {
      let newShape = new Konva.Rect({
        id: shape.id,
        name: 'crop_rect',
        map_type: 'shape',
        category: shape.category,
        order: shape.order,
        case: shape.case_column,
        x_pos: Number(shape.x_pos),
        y_pos: Number(shape.y_pos),
        width: Number(shape.width),
        height: Number(shape.height),
        edit_type: 'created',
        key: shape.key,
        dataType: shape.data_type,
        dateFormat: shape.date_format,
        date_category: shape.date_category,
        description: shape.description,
        required: shape.required,
        extract: shape.extract,
        extract_by_words: shape.extract_by_words,
        redact_field: shape.redact_field,
        show_field: shape.show_field,
        sensitive_data: shape.sensitive_data,
        key_alias: shape.key_alias,
        template_id: shape.template_id,
        uniq_id: (Date.now()).toString() + shape.key,
        stroke: this.theme[this.selectedTheme].strokeColor,
        strokeWidth: 3,
        draggable: true,
        selected: false
      })
      return newShape
    },

    bindListeners (shape) {
      let vm = this
      shape.on('dragstart', function (evt) {
        vm.clearSelection()
        vm.canDelete = true
        vm.highlightShape = this
        vm.highlightSelection(this)
      })

      shape.on('dragend', function (evt) {
        shape.setAttrs({
          x_pos: shape.attrs.x,
          y_pos: shape.attrs.y
        })
        if (shape.name() === 'group') {
          vm.updateGroupShapes(shape)
        }
        vm.pushToHistory()
      })

      shape.on('click', function (el) {
        vm.clearSelection()
        vm.canDelete = true

        if (this.attrs.map_type === 'shape') {
          vm.transformShape = this
          vm.attachTransformer()
        }

        vm.highlightShape = this
        vm.highlightSelection(this)
      })

      shape.on('transformend', function () {
        shape.setAttrs({
          x_pos: this.x(),
          y_pos: this.y(),
          act_width: this.width() * this.scaleX(),
          act_height: this.height() * this.scaleY()
        })
        vm.pushToHistory()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/populateMapping.js